import React, { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * Escolha dos grupos de acesso de um documento restrito.
 *
 * Usa caixas de selecao em vez de <select multiple>: o multiple exige
 * Ctrl+clique para marcar mais de um e desmarca tudo num clique distraido,
 * o que e facil de errar sem perceber num controle de acesso.
 */
export default function GroupPicker({ value, onChange }) {
  const [groups, setGroups] = useState([]);
  const [state, setState] = useState('loading');

  useEffect(() => {
    // Rota enxuta: a /groups administrativa nega usuario Padrao, que e
    // justamente quem mais cria documento.
    api.get('/groups/options')
      .then(({ data }) => {
        setGroups(data.data);
        setState(data.data.length ? 'ready' : 'empty');
      })
      .catch(() => setState('error'));
  }, []);

  function toggle(id) {
    onChange(value.includes(id) ? value.filter((g) => g !== id) : [...value, id]);
  }

  if (state === 'loading') {
    return <div className="text-sm text-ink-muted">Carregando grupos...</div>;
  }

  if (state === 'error') {
    return (
      <div className="p-3 rounded-md text-sm bg-status-rejected/10 text-status-rejected border border-status-rejected/20">
        Não foi possível carregar os grupos de acesso.
      </div>
    );
  }

  if (state === 'empty') {
    return (
      <div className="p-3 rounded-md text-sm bg-surface-inset text-ink-secondary">
        Nenhum grupo de usuários cadastrado. Um administrador precisa criar
        grupos antes de restringir o acesso — sem grupo, um documento restrito
        fica visivel apenas ao autor e aos administradores.
      </div>
    );
  }

  return (
    <div>
      <div className="border rounded-md divide-y divide-subtle max-h-[200px] overflow-y-auto">
        {groups.map((g) => (
          <label key={g.id} className="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer hover:bg-surface-inset">
            <input
              type="checkbox"
              checked={value.includes(g.id)}
              onChange={() => toggle(g.id)}
            />
            {g.name}
          </label>
        ))}
      </div>
      <div className="text-xs text-ink-muted mt-1">
        {value.length === 0
          ? 'Nenhum grupo selecionado — apenas autor e administradores verao o documento.'
          : `${value.length} grupo(s) selecionado(s).`}
      </div>
    </div>
  );
}
